export let ElSelectArrowFix = {};

ElSelectArrowFix.install = function (Vue) {
    Vue.prototype.$elSelectArrowFix = function () {
        let elSelectItems = document.getElementsByClassName("el-input__suffix");

        for (let i = 0; i < elSelectItems.length; i++) {
            elSelectItems[i].onclick = function (event) {
                if (event.target && event.target.closest('.el-input.el-input--suffix').className.indexOf('is-focus') + 1) {
                    let childrenElements = event.target.closest('.el-select.form__select').children;

                    for (let j = 0; j < childrenElements.length; j++) {
                        if (childrenElements[j].className.indexOf('el-select__tags') + 1) {
                            let tagsElements = childrenElements[j].children;
                            for (let k = 0; k < tagsElements.length; k++) {
                                if (tagsElements[k].type === 'text') {
                                   tagsElements[k].click();
                                   tagsElements[k].click();
                                }

                                setTimeout(() => {
                                    if (event.target.closest('.el-input.el-input--suffix').className.indexOf('is-focus') + 1) {
                                        event.target.closest('.el-input.el-input--suffix').click();
                                    }
                                }, 100);
                            }
                        }
                    }
                }
            }
        }
    }
};
